import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

export const createKey = ({ requestId } = {}) => [
  'currentPaymentTypes',
  requestId,
];

const currentPaymentTypesQuery = async ({ requestId }) => {
  return request.get(
    `/Request/current_payment_types/${requestId}`,
    {},
    `При загрузке текущих способов оплаты произошла ошибка`
  );
};

export const useCurrentPaymentTypes = (params, options) =>
  useQuery(createKey(params), () => currentPaymentTypesQuery(params), options);
